const INPUT_PROPS = {
  id: {
    type: String,
    required: true
  },
  name: {
    type: String,
    default: ""
  },
  rules: {
    type: String,
    default: ""
  },
  label: {
    type: String,
    default: ""
  },
  loading: {
    type: Boolean,
    default: false
  },
  tooltip: {
    type: String,
    default: null
  },
  type: {
    type: String,
    default: "text"
  },
  placeholder: {
    type: String,
    default: null
  },
  disabled: {
    type: Boolean,
    default: false
  },
  modelValue: {
    type: [String, Number, Object],
    default: void 0
    // /!\ Do not set to null, it will break v-model and vee-validate initialValue behavior
  },
  syncVModel: {
    type: Boolean,
    default: true
  },
  valueFormatter: {
    type: Function,
    default: null
  },
  displayedValueFormatter: {
    type: Function,
    default: null
  },
  inputMode: {
    type: String,
    default: "text"
  },
  min: {
    type: [String, Number],
    default: void 0
  },
  max: {
    type: [String, Number],
    default: void 0
  },
  skeleton: {
    type: Boolean,
    default: false
  },
  required: {
    type: Boolean,
    default: false
  },
  inputRef: {
    type: Object,
    default: null
  },
  // If input type is hidden, it hide input but show errors
  showErrors: {
    type: Boolean,
    default: true
  }
};
const INPUT_NUMBER_PROPS = {
  ...INPUT_PROPS,
  ...{
    min: {
      type: Number,
      default: void 0
    },
    max: {
      type: Number,
      default: void 0
    },
    decimals: {
      type: Number,
      default: 0
    },
    allowNegative: {
      type: Boolean,
      default: false
    }
  }
};
const INPUT_AUTOCOMPLETE_PROPS = {
  ...INPUT_PROPS,
  ...{
    options: {
      type: Array,
      default: () => []
    }
  }
};
const INPUT_TEXTAREA_PROPS = {
  ...INPUT_PROPS,
  ...{
    rows: {
      type: Number,
      default: 0
    },
    cols: {
      type: Number,
      default: 0
    }
  }
};
export {
  INPUT_AUTOCOMPLETE_PROPS,
  INPUT_NUMBER_PROPS,
  INPUT_PROPS,
  INPUT_TEXTAREA_PROPS
};
//# sourceMappingURL=input.es.js.map
